import { keyboardService } from "../../services/keyboardService";
import { CraneAction } from "../../types";

export interface KeyboardSlice {
  // Actions
  initializeKeyboardControls: () => void;
  cleanupKeyboardControls: () => void;
}

export const createKeyboardSlice = (set: any, get: any): KeyboardSlice => {
  let unsubscribeRawKey: (() => void) | undefined;

  return {
    // Actions
    initializeKeyboardControls: () => {
      const {
        incrementCraneParameter,
        decrementCraneParameter,
        updateCraneParameter,
        cycleSuggestedIndex,
        assignSuggestedToIndex,
        cancelWidgetSuggestion,
      } = get();

      // Register action handler with keyboard service
      keyboardService.onAction((action: CraneAction) => {
        switch (action.type) {
          case "increment":
            incrementCraneParameter(action.parameter, action.amount || 1);
            break;
          case "decrement":
            decrementCraneParameter(action.parameter, action.amount || 1);
            break;
          case "set":
            if (action.value !== undefined) {
              updateCraneParameter(action.parameter, action.value);
            }
            break;
        }
      });

      // Raw key handling for widget suggestion flow
      if (unsubscribeRawKey) unsubscribeRawKey();
      unsubscribeRawKey = keyboardService.onRawKey((code) => {
        console.log("onRawKey", code);
        const state = get();
        if (!state.isSuggestingWidget) return;
        if (code === "BracketLeft") {
          cycleSuggestedIndex(-1);
        } else if (code === "BracketRight") {
          cycleSuggestedIndex(1);
        } else if (code === "Enter") {
          assignSuggestedToIndex();
        } else if (code === "Escape") {
          cancelWidgetSuggestion();
        }
      });

      // Start the keyboard service with pre-configured mappings
      keyboardService.registerMappings([
        // Boom speed controls (Up/Down arrows)
        {
          key: "ArrowUp",
          action: { type: "increment", parameter: "boomSpeed", amount: 5 },
          description: "Increase boom speed",
        },
        {
          key: "ArrowDown",
          action: { type: "increment", parameter: "boomSpeed", amount: -5 },
          description: "Decrease boom speed",
        },

        // Speed controls (Shift + arrows)
        {
          key: "KeyW",
          action: { type: "increment", parameter: "speed", amount: 5 },
          description: "Increase speed",
        },
        {
          key: "KeyS",
          action: { type: "increment", parameter: "speed", amount: -5 },
          description: "Decrease speed",
        },

        // Slew speed controls (Left/Right arrows)
        {
          key: "ArrowLeft",
          action: { type: "increment", parameter: "slewSpeed", amount: -5 },
          description: "Slew left faster",
        },
        {
          key: "ArrowRight",
          action: { type: "increment", parameter: "slewSpeed", amount: 5 },
          description: "Slew right faster",
        },

        // Load controls
        {
          key: "KeyL",
          action: { type: "increment", parameter: "mhLoad", amount: 50 },
          description: "Increase MH load",
        },
        {
          key: "KeyK",
          action: { type: "increment", parameter: "mhLoad", amount: -50 },
          description: "Decrease MH load",
        },

        // Special actions
        {
          key: "Space",
          action: { type: "set", parameter: "speed", value: 0 },
          description: "Set speed to 0",
        },
        {
          key: "Digit0",
          action: { type: "set", parameter: "speed", value: 25 },
          description: "Reset speed to default",
        },
      ]);

      keyboardService.enable();
    },

    cleanupKeyboardControls: () => {
      if (unsubscribeRawKey) {
        unsubscribeRawKey();
        unsubscribeRawKey = undefined;
      }
      keyboardService.disable();
    },
  };
};
